import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraHubGrid } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
export function WhereTheyShowUp({ cards }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Where they show up"
            }),
            cards.length ? /*#__PURE__*/ _jsx(SpecraHubGrid, {
                columns: 3,
                renderLink: renderRouterLink,
                getItemTestId: ()=>Testids.registryCompany.showUpCard,
                items: cards.map((c, i)=>({
                        id: `${c.plane}-${i}`,
                        title: c.title,
                        description: c.summary || undefined,
                        eyebrow: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: c.plane === 'GROWTH' ? 'success' : c.plane === 'DELIVERY' ? 'teal' : 'info',
                            children: c.plane.charAt(0) + c.plane.slice(1).toLowerCase()
                        }),
                        href: c.primary ? registryHref(c.primary) ?? undefined : undefined
                    }))
            }) : /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                tone: "muted",
                size: "body-ui",
                children: "Nothing you can see links to this company yet."
            })
        ]
    });
}
